import { render } from "./App.vue?vue&type=template&id=8f613ec0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8f613ec0&lang=scss"

import exportComponent from "../_pkgs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__